import { useSnackbar } from 'notistack';
import { useHistory, useLocation } from 'react-router-dom';

// core
import * as api from '_core/utils/api';
import { useVisitorInfo } from '_core/utils/visitorInfo';
import { useGlobal } from '_core/hooks/useGlobal';
import { API_ERROR } from 'config';

// translate — это getLangString из withLang
export const useRequest = (translate) => {
  const { enqueueSnackbar } = useSnackbar();
  const visitorInfo = useVisitorInfo();
  const history = useHistory();
  const location = useLocation();
  const global = useGlobal();
  const ROUTE_URL = global?.config?.ROUTE_URL || { LOGIN: '/login' };

  const errorMessage = (message) => {
    const baseMassage = translate(message?.message1);
    return baseMassage;

/*    let translated = '';
    let key = '';

    key = message?.message2 ?? '';
    translated = translate(key);
    if (key && translated !== key) {
      return baseMassage + '. ' + translated;
    }
    key = message?.message3 ?? '';
    translated = translate(key);
    if (key && translated !== key) {
      return baseMassage + '. ' + translated;
    }
    return baseMassage; */
    
  };

  const onFailure = (error, method) => {
    process.env.NODE_ENV !== 'production' && console.error(error);

    const isAuthorized = visitorInfo.isAuthorized();
    if (!isAuthorized && (
      error.code === API_ERROR.VISITOR_UNAUTHORIZED || 
      error.code === 'visitor-unauthorized'
    )) {
      return { handled: true };
    }

    if (error.code === API_ERROR.VISITOR_UNAUTHORIZED || error.code === 'visitor-unauthorized') {
      visitorInfo.set(null);
      
      if (location.pathname !== ROUTE_URL.LOGIN) {
        history.push(ROUTE_URL.LOGIN);
      }
      
      return { handled: true };
    }

    const raw = error.rawMessage; // то, что мы передали из fetchData
     let message = '';
  
    if (typeof raw === 'object' && raw !== null) {
      message = errorMessage(raw);        // message1/message2/message3
    } else {
      message = error.message;            // обычная строка
    }
  
    enqueueSnackbar(message, { variant: 'error' });

  };

  const queue = async (method, param, props) => {
    try {
      return await api.request(method, param, props);
    } catch (e) {
      const result = onFailure(e, method);
      
      if (result && result.handled) {
        return null;
      }

      throw e;
    }
  };

  return { queue, onFailure };
};
